/* istanbul ignore file */
import React from 'react';
import { DefaultDropdownProps, EnumDropdown } from 'framework/form';

const BACKGROUND_CHECK_RESULTS = {
  PASSED: 'Passed',
  NOT_PASSED: 'Not Passed',
};

const BackgroundCheckResultDropdown = (props: DefaultDropdownProps) => (
  <EnumDropdown {...props} options={BACKGROUND_CHECK_RESULTS} placeholder="Select check result" />
);

export default BackgroundCheckResultDropdown;
